import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import blogVisitService from '../../services/BlogVisitService';

const BlogVisitCounter = ({ postSlug, postData = null, className = '' }) => {
  const visitCount = blogVisitService.getVisitCount(postSlug, postData);
  const formattedCount = blogVisitService.formatVisitCount(visitCount);

  return (
    <div className={`blog-visit-counter ${className}`}>
      <FontAwesomeIcon icon={faEye} className="blog-visit-counter__icon" />
      <span className="blog-visit-counter__count">{formattedCount}</span>
    </div>
  );
};

export default BlogVisitCounter;
